import { SelectorOption } from '@Components/ModalEditWidget/modal-edit-constants';
import { FieldValue, OverviewField, OverviewFieldType } from './entity-overview-form-constants';

export const displayValue = (field: OverviewField, value: FieldValue): string => {
  if (value == null || value === '') return '—';
  if (field.type === OverviewFieldType.CHECKBOX) {
    const isChecked = field.toChecked ? field.toChecked(value) : Boolean(value);
    return isChecked ? 'Yes' : 'No';
  }
  if (field.format) return field.format(value);
  return String(value);
};

export const selectOptions = (options: SelectorOption[] = []): { label: string; value: string }[] =>
  options.map(option => ({ label: String(option.label), value: String(option.value) }));
